export const roadMapCommonData = {
    mainHeading: "Our Proven Roadmap to Ensure Your Success",
    sectionDescription: "As a leading QA service provider, we follow a structured roadmap to ensure the highest software quality. From initial assessment to ongoing support, our systematic approach aligns with your business objectives, guarantees robust testing, & drives continuous improvement.",

    roadMapHeading0: "Discovery & Planning",
    roadMapDescription0: "As a leading AI development services provider, we follow a systematic approach that guarantees alignment with your business goals, delivers high-quality solutions, & provides continuous improvement.",

    roadMapHeading1: "Design & Proof of Concept",
    roadMapDescription1: "We design the solution architecture & develop a proof of concept, validating ideas to ensure feasibility & alignment with your vision.",

    roadMapHeading2: "Development & Testing",
    roadMapDescription2: "We deliver robust solutions through seamless development, rigorous testing, & ongoing maintenance for optimal performance.",

    roadMapHeading3: "Implementation & Support",
    roadMapDescription3: "Finally, we implement the solutions ensuring a smooth transition, & offer ongoing maintenance to keep your solution optimized & up-to-date.",
}